import type { WhatsNewSourceI } from "@/modules/whats-new/data/use-whats-new-cards";
import { resolveWhatsNewEntry } from "@/modules/whats-new/lib/audience";
import type { WhatsNewAudienceT } from "@/modules/whats-new/lib/types";

import type { TopTenDataI } from "../lib/data";
import { TOP_TEN_2026_10_26 } from "./entry";

/**
 * The Top 10 announcement, only while the backend switch is on. A switched-off
 * backend or a failed read settles with no card, so it never holds the other
 * sources back.
 */
export const resolveTopTenWhatsNewSource = (
  audience: WhatsNewAudienceT | null,
  topTen: TopTenDataI | undefined,
  isPending: boolean
): WhatsNewSourceI => {
  if (!audience) {
    return { cards: [], isSettled: false };
  }

  if (isPending) {
    return { cards: [], isSettled: false };
  }

  const card = topTen?.isSwitchedOn
    ? resolveWhatsNewEntry(TOP_TEN_2026_10_26, audience)
    : null;

  return {
    cards: card ? [card] : [],
    isSettled: true,
  };
};
